var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        centerAndDecreasesPadding: "",
        maxWidth: "550px",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      on: { close: _vm.handleClose },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { dark: "", outline: "", disabled: !_vm.hasAnyDate },
                  on: { click: _vm.clearDates }
                },
                [_vm._v(" Limpar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", disabled: !_vm.isRangeValid },
                  on: { click: _vm.apply }
                },
                [_vm._v(" Filtrar ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v("Selecionar período")
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticClass: "py-1", attrs: { cols: "6", sm: "12" } },
                  [
                    _c("input-by-type", {
                      attrs: {
                        type: "date_new_ux",
                        "label-external": "Início",
                        value: _vm.inputInicio,
                        "max-date": _vm.maxDateBR
                      },
                      on: { input: _vm.handleInputInicio }
                    }),
                    _vm.inicioErrorMessage
                      ? _c(
                          "span",
                          { staticClass: "wallet-custom-date__error text-xxs" },
                          [_vm._v(" " + _vm._s(_vm.inicioErrorMessage) + " ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "py-1", attrs: { cols: "6", sm: "12" } },
                  [
                    _c("input-by-type", {
                      attrs: {
                        type: "date_new_ux",
                        "label-external": "Fim",
                        value: _vm.inputFim,
                        "max-date": _vm.maxDateBR
                      },
                      on: { input: _vm.handleInputFim }
                    }),
                    _vm.fimErrorMessage
                      ? _c(
                          "span",
                          { staticClass: "wallet-custom-date__error text-xxs" },
                          [_vm._v(" " + _vm._s(_vm.fimErrorMessage) + " ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }